import React, { useState, useEffect } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';
// import { NoHeaderTableUpdate } from '../../Helpers/requests';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import ExportToCsv from '../../Helpers/CsvExport';

import { DataGrid } from '@mui/x-data-grid';
import { Box, Grid, Typography, Modal, Button } from '@mui/material';

import UsersAutocomplete from '../CommonComponents/UsersAutocomplete';
import TechAutocomplete from '../CommonComponents/TechAutocomplete';
import DatePicker from '../CommonComponents/DatePicker';

import { gridStyle } from './gridStyle';

import CircleIcon from '@mui/icons-material/Circle';
import { changeFirstToUpper } from '../../Helpers/helpers';

const PayrollReport = () => {
  const [loggedData, setLoggedData] = useState([]);
  const [loggedPage, setLoggedPage] = useState(0);
  const [loggedPageSize, setLoggedPageSize] = useState(25);
  const [loggedSort, setLoggedSort] = useState([]);
  const [loggedFilter, setLoggedFilter] = useState([]);
  const [loggedTotalRows, setLoggedTotalRows] = useState(0);

  const [clockData, setClockData] = useState([]);
  const [ticketData, setTicketData] = useState([]);
  const [utilisation, setUtilisation] = useState([]);

  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  //FILTERS
  // const [techSelected, setTechSelected] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [fullFilterBlob, setFullFilterBlob] = useState([]);
  const [rangeFilterBlob, setRangeFilterBlob] = useState([]);
  const [useType, setUseType] = useState(localStorage.getItem('type'));
  const [rowData, setRowData] = useState({});

  const [techId, setTechId] = useState(null);

  const handleFilterChange = (data, type) => {
    setTechId(data.id);
    switch (type) {
      case 'tech_username':
        let oldData = [...fullFilterBlob];
        let tempData = oldData
          .slice()
          .filter((item) => item.field !== 'tech_username');

        data === '%'
          ? setFullFilterBlob([...tempData])
          : setFullFilterBlob([
              ...tempData,
              {
                field: 'tech_username',
                search: data,
                strict: true,
              },
            ]);
        break;
      default:
        break;
    }
  };

  const padLeft = (intVal) => {
    return intVal < 10 ? `0${intVal}` : intVal;
  };

  const handleRangeChange = (data, type) => {
    let startTime = startDate;
    let endTime = endDate;
    let oldData = [...rangeFilterBlob];

    switch (type) {
      case 'start_time':
        startTime = data;

        let currentDate = new Date();
        let dateString = `${currentDate.getFullYear()}-${padLeft(
          currentDate.getMonth() + 1
        )}-${padLeft(currentDate.getDate())} 23:59:59`;

        let tempStartData = oldData
          .slice()
          .filter((item) => item.field !== 'start_time');

        data === '%'
          ? setRangeFilterBlob([...tempStartData])
          : setRangeFilterBlob([
              ...tempStartData,
              {
                field: 'start_time',
                start: data + ' 00:00:00',
                stop: dateString,
              },
            ]);
        setStartDate(data);
        break;
      case 'stop_time':
        endTime = data;
        let firstDate = new Date(0);

        let dateString1 = `${firstDate.getFullYear()}-${padLeft(
          firstDate.getMonth() + 1
        )}-${padLeft(firstDate.getDate())} 00:00:00`;

        let tempEndData = oldData
          .slice()
          .filter((item) => item.field !== 'stop_time');

        data === '%'
          ? setRangeFilterBlob([...tempEndData])
          : setRangeFilterBlob([
              ...tempEndData,
              {
                field: 'stop_time',
                start: dateString1,
                stop: data + ' 23:59:59',
              },
            ]);
        setEndDate(data);
        break;
      default:
        break;
    }
  };

  const handelDate = (date, subVal) => {
    const inDate = date;
    // let outDate = inDate.substring(0, inDate.lastIndexOf('T') + 1);
    // outDate = outDate + subVal;
    // console.log(`Date: ${date} \nSubval: ${subVal} \nOutDate:`);
    return date;
  };

  const handleClearDateRange = () => {
    if (rangeFilterBlob.length > 0) {
      setRangeFilterBlob([]);
      const newDate = new Date();
      setStartDate(newDate);
      setEndDate(newDate);
    }
  };

  useEffect(() => {
    const newDate = new Date();
    setStartDate(newDate);
    setEndDate(newDate);
  }, []);

  useEffect(() => {
    checkClockData(loggedData).then((data) => setClockData(data));
    checkUtilisation(loggedData).then((data) => {
      setUtilisation(data);
    });
    checkTicketTimes(loggedData).then((data) => setTicketData(data));
  }, [loggedData]);

  const checkClockData = async (arr) => {
    let data;
    if (arr['day_clock_in'] === undefined) {
      data = { date: '' };
    } else {
      data = await arr['day_clock_in'];
    }
    return data;
  };
  const checkUtilisation = async (arr) => {
    let data = [];
    if (arr['utilisation'] === undefined) {
      data = { labour_hours: 0 };
    } else {
      let tmpData = await arr['utilisation'];

      data = [...data, { ...tmpData, id: 1 }];
    }
    console.log('new data', data);
    return data;
  };
  const checkTicketTimes = async (arr) => {
    let data;
    if (arr['ticket_clock_in'] === undefined) {
      data = { labour_hours: 0 };
    } else {
      data = await arr['ticket_clock_in'];
    }
    return data;
  };

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_reports`,
        setDataFunc: setLoggedData,
        setLoadingFunc: setLoading,
        setRows: setLoggedTotalRows,
        startDate: startDate,
        endDate: endDate,
        userId: techId,
        logout,
      },
      'payroll_report'
    );
  }, [techId, startDate, endDate]);

  const clockedInColumns = [
    { field: 'date', headerName: 'Date', width: 150, flex: 1 },
    {
      field: 'day_of_week',
      headerName: 'Day',
      width: 150,
      flex: 1,
    },
    {
      field: 'start_time',
      headerName: 'Payroll Clock In',
      width: 150,
      flex: 1,
    },
    {
      field: 'start_time_override',
      headerName: 'Tech Clock In',
      width: 150,
      flex: 1,
    },
    {
      field: 'stop_time',
      headerName: 'Payroll Clock Out',
      width: 150,
      flex: 1,
    },
    {
      field: 'stop_time_override',
      headerName: 'Tech Clock Out',
      width: 150,
      flex: 1,
    },
    {
      field: 'total_work_hours',
      headerName: 'Total Work Hours',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'total_ot_hours',
      headerName: 'Total OT',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'ot1_hours',
      headerName: 'Total x1.5 OT',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'ot2_hours',
      headerName: 'Total x2.0 OT',
      width: 150,
      flex: 1,
      type: 'number',
    },
  ];

  const utilisationColumns = [
    {
      field: 'labour_hours',
      headerName: 'Labour Hours',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'travel_hours',
      headerName: 'Travel Hours',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'total_allocated',
      headerName: 'Total Allocated',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'total_work_hours',
      headerName: 'Total Work Hours',
      width: 150,
      flex: 1,
      type: 'number',
    },
    {
      field: 'utilisation_rate',
      headerName: 'Utilisation Rate',
      width: 150,
      flex: 1,
      type: 'number',
    },
  ];
  const timeColumns = [
    {
      field: 'date',
      headerName: 'Date',
      width: 150,
      flex: 1,
    },
    {
      field: 'day_of_week',
      headerName: 'Day',
      width: 150,
      flex: 1,
    },
    {
      field: 'ticket_type',
      headerName: 'Ticket Type',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <Typography>{changeFirstToUpper(data.row.ticket_type)}</Typography>
      ),
    },
    {
      field: 'billing_type',
      headerName: 'Billing',
      width: 150,
      flex: 1,
    },
    {
      field: 'store_name',
      headerName: 'Store Name',
      width: 150,
      flex: 1,
    },
    {
      field: 'issue_reported',
      headerName: 'Issue/Problem Reported',
      width: 250,
      flex: 1,
    },
    {
      field: 'total_labour_time',
      headerName: 'Total Labour Time',
      width: 250,
      flex: 1,
    },
    {
      field: 'total_travel_time',
      headerName: 'Total Travel Time',
      width: 250,
      flex: 1,
    },
    {
      field: 'total_time',
      headerName: 'Total Ticket Time',
      width: 250,
      flex: 1,
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '65vh', width: 2048 }}>
      <Box maxWidth={1024}>
        <Grid container columnGap={1}>
          <Grid xs={12} md={2}>
            <TechAutocomplete
              nameLabel='Tech Username'
              filterData={(data) => handleFilterChange(data, 'tech_username')}
            />
          </Grid>
          <Grid xs={12} md={6} container columnGap={1}>
            <Grid xs={12} md={4}>
              <DatePicker
                dateLabel='Start Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '00:01:01'), 'start_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={4}>
              <DatePicker
                dateLabel='End Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '23:59:59'), 'stop_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant='outlined'
                size='large'
                onClick={handleClearDateRange}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant='contained'
              size='large'
              type='info'
              onClick={() => {
                new ExportToCsv('payroll_report_clock_in').ExportRawData(
                  clockData
                );
                new ExportToCsv('payroll_report_tickets').ExportRawData(
                  ticketData
                );
                new ExportToCsv('payroll_report_util').ExportRawData(
                  utilisation
                );
              }}
            >
              Extract Data
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box height='30vh' width='100%'>
        <Grid container columnGap={1} rowGap={1}>
          {' '}
          <Grid item xs={12} align='center'>
            <Typography
              variant='h6'
              align='center'
              xs={{
                background: '#ebedf8',
                margin: '0 auto',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
                align: 'center',
              }}
              sx={{ fontWeight: 'bold' }}
            >
              User Clocked In Times
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <DataGrid
              id='day_clock_in'
              sx={{
                ...gridStyle,
                width: '100%',
                height: '30vh',
              }}
              // rows={loggedData}
              rows={clockData}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                // setLoggedPage(0);
                setLoggedSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={loggedPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setLoggedPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setLoggedPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={clockedInColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
          </Grid>
          <Grid item xs={3.9}>
            {console.log(loggedData)}
            <DataGrid
              id='utilisation'
              sx={{
                ...gridStyle,
                // maxHeight: '100%',
                width: '100%',
                height: '30vh',
              }}
              rows={utilisation}
              // getRowId={(row) => row?.tech_id}
              // rowCount={loggedTotalRows}
              // loading={loading}
              pagination
              // sortingMode='server'
              // filterMode='server'
              onSortModelChange={(model) => {
                // setLoggedPage(0);
                setLoggedSort(model);
              }}
              // onFilterModelChange={(model) => {
              //   setLoggedPage(0);
              //   setLoggedFilter(model.quickFilterValues);
              // }}
              page={loggedPage}
              // pageSize={loggedPageSize}
              // initialState={{
              //   pagination: {
              //     paginationModel: { pageSize: 5, page: 0 },
              //   },
              // }}
              // paginationMode='client'
              onPageChange={(newPage) => {
                setLoggedPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setLoggedPage(0);
                setLoggedPageSize(newPageSize);
              }}
              columns={utilisationColumns}
              onRowClick={(params) => {}}
              // rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              autoPageSize
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              initialState={{
                aggregation: {
                  model: {
                    calc2: 'sum',
                    year: 'sum',
                  },
                },
              }}
              componentsProps={
                {
                  // getRowId: loggedData.tech_id,
                  // toolbar: {
                  //   updateOnclick: () => {
                  //     setUpdateData((i) => i + 1);
                  //   },
                  //   filterOnClick: () => {
                  //     // handleFilterOpen();
                  //   },
                  //   // modalState: modalState,
                  // },
                }
              }
            />
          </Grid>
          <Grid item xs={12} align='center'>
            <Typography
              variant='h6'
              xs={{
                background: '#ebedf8',

                width: '100% !important',
                // justifyContent: 'center',
                // alignItems: 'center',

                textAlign: 'center',
                align: 'center',
              }}
              sx={{ fontWeight: 'bold' }}
            >
              Ticket Times
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              id='ticket_times'
              sx={{ ...gridStyle, height: '35vh', width: '100%' }}
              rows={ticketData}
              // rowCount={totalRows}
              // loading={loading}
              pagination
              sortingMode='server'
              filterMode='server'
              onSortModelChange={(model) => {
                setPage(0);
                setSort(model);
              }}
              onFilterModelChange={(model) => {
                setPage(0);
                setFilter(model.quickFilterValues);
              }}
              page={page}
              pageSize={pageSize}
              paginationMode='server'
              onPageChange={(newPage) => {
                setPage(newPage);
              }}
              onPageSizeChange={(newPageSize) => {
                setPage(0);
                setPageSize(newPageSize);
              }}
              columns={timeColumns}
              onRowClick={(params) => {}}
              //   onRowDoubleClick={(params) => {
              //     setRowData(params.row);
              //     // getMyRowData(params.row);
              //     // setEditOrSave('editMode');
              //   }}
              rowsPerPageOptions={[25, 50, 100]}
              // components={{ Toolbar: CustomCustomerToolbar }}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              componentsProps={{
                toolbar: {
                  updateOnclick: () => {
                    setUpdateData((i) => i + 1);
                  },
                  filterOnClick: () => {
                    // handleFilterOpen();
                  },
                  // modalState: modalState,
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PayrollReport;

const ticketType = (val) => {
  switch (val) {
    case 'day_start':
      return 'Day Clock';
    case 'repair_ticket':
      return 'Repair Ticket';
    case 'install_ticket':
      return 'Install Ticket';
    default:
      break;
  }
};
